module.exports = __webpack_public_path__ + "static/elevate_boss_white_logo.54267893.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/elevate_boss_white_logo.png
// module id = 3082
// module chunks = 31740773553394